import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProjects, Project } from '../utils/projectStorage';

const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    const loadedProjects = getProjects();
    setProjects(loadedProjects);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content fade-in-up">
          <div className="accent-line" style={{margin: '0 auto var(--spacing-sm)'}}></div>
          <h1 className="display-2 hero-title">Projeler</h1>
          <p className="body-large hero-description">
            Tamamladığım mimari projeler, 3D modeller ve teknik çizimler
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="section">
        <div className="container">
          {projects.length === 0 ? (
            <div className="text-center" style={{padding: 'var(--spacing-xl)'}}>
              <p className="body-large text-secondary">Henüz proje eklenmemiş</p>
            </div>
          ) : (
            <div className="project-grid">
              {projects.map((project, index) => (
                <Link 
                  key={project.id} 
                  to={`/proje/${project.id}`}
                  style={{textDecoration: 'none', color: 'inherit'}}
                >
                  <div className={`project-card card scale-in animate-delay-${(index % 4) + 1}`}>
                    {project.image ? (
                      <img 
                        src={project.image} 
                        alt={project.title}
                        className="card-image"
                        style={{width: '100%', height: '100%', objectFit: 'cover'}}
                      />
                    ) : (
                      <div className="img-placeholder">
                        <span style={{fontSize: '5rem'}}>{project.icon}</span>
                      </div>
                    )}
                    <div className="project-overlay">
                      <p className="project-category">{project.category} • {project.year}</p>
                      <h3 className="project-title">{project.title}</h3>
                      <p className="body-small" style={{marginTop: '0.5rem', opacity: 0.9}}>
                        {project.description.length > 150 
                          ? project.description.substring(0, 150) + '...' 
                          : project.description}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-sm" style={{background: 'var(--color-bg-card)'}}>
        <div className="container">
          <div className="text-center">
            <h2 className="heading-1 mb-md">Bir Projeniz mi Var?</h2>
            <p className="body-large text-secondary mb-lg">
              Hayalinizdeki mimari projeyi birlikte gerçekleştirelim
            </p>
            <a href="/#iletisim" className="btn btn-primary">
              İletişime Geçin
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
